import { Routes, Route } from 'react-router-dom'
import { useEffect, useState } from 'react'
import DashboardLayout from './components/DashboardLayout'
import Dashboard from './pages/Dashboard'
import Scans from './pages/Scans'
import Violations from './pages/Violations'
import Settings from './pages/Settings'
import { subscribeToViolations, subscribeToScans } from './services/supabase'

function App() {
  const [realtimeEnabled, setRealtimeEnabled] = useState(false)

  useEffect(() => {
    // Set up realtime subscriptions
    const violationsChannel = subscribeToViolations((payload) => {
      console.log('New violation:', payload)
      // Handle new violation (e.g., show notification)
    })

    const scansChannel = subscribeToScans((payload) => {
      console.log('Scan update:', payload)
      // Handle scan update
    })

    setRealtimeEnabled(true)

    return () => {
      // Clean up subscriptions
      violationsChannel.unsubscribe()
      scansChannel.unsubscribe()
    }
  }, [])

  return (
    <DashboardLayout realtimeEnabled={realtimeEnabled}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/scans" element={<Scans />} />
        <Route path="/violations" element={<Violations />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </DashboardLayout>
  )
}

export default App